import { CURRENCY } from "../../constants/languages";

export const languageSelector = state => state.settings.language || 'en';
export const currencySelector = state => state.settings.currency || CURRENCY.eur;

export const languageSelectorWithoutDefault = state => state.settings.language;
export const currencySelectorWithoutDefault = state => state.settings.currency;
export const cookiesPolicyDismissedSelector = state => state.settings.cookiesPolicyDismissed;
